import { z } from "zod";

export const refreshTokenSchema = z
	.object({
		refresh_token: z.string().optional(),
	})
	.optional();

export type RefreshTokenPayload = z.infer<typeof refreshTokenSchema>;
